import "@hotwired/turbo-rails";
import "@/tom-select.js";
import * as bootstrap from "bootstrap";

window.bootstrap = bootstrap;
